var Size;
(function (Size) {
  Size["EXTRA_SMALL"] = "xs";
  Size["SMALL"] = "sm";
  Size["MEDIUM"] = "md";
  Size["LARGE"] = "lg";
  Size["EXTRA_LARGE"] = "xl";
})(Size || (Size = {}));

export { Size };
//# sourceMappingURL=size.mjs.map
